// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, enumOf, objectOf, maybe } from "@altostra/type-validations";
import { boolean, number, string } from "@altostra/type-validations/lib/primitives";

import type {
  BrandGuidelinesSynthesisSourceError,
  PostwsGenerativeAiAppGroupIdBrandGuidelinesSynthesisResult,
} from "./types";

const isBrandGuidelinesSynthesisSourceError = objectOf<BrandGuidelinesSynthesisSourceError>({
  type: enumOf<"url" | "document">("url", "document"),
  ref: string,
  error: string,
});

export const isPostwsGenerativeAiAppGroupIdBrandGuidelinesSynthesisResult =
  objectOf<PostwsGenerativeAiAppGroupIdBrandGuidelinesSynthesisResult>({
    status: number,
    brand_personality: maybe(string, true),
    synthesized: maybe(boolean, true),
    source_errors: maybe(arrayOf(isBrandGuidelinesSynthesisSourceError), true),
    error: maybe(string, true),
  });
